import type React from 'react';

import type { AiChatReference } from '~/components/AiChat/types';

import { DocumentReferenceTrigger } from './DocumentReferenceTrigger';
import { ExpertReferenceTrigger } from './ExpertReferenceTrigger';

export interface ReferenceTriggerProps {
  reference: AiChatReference;
  children: React.ReactNode;
}

interface ReferenceKind {
  Trigger: React.FC<ReferenceTriggerProps>;
  /** The key the caller's map and the claim's reference cache hold this kind's reference under. */
  cacheKey: (id: string) => string;
}

/**
 * The kinds of `src:<kind>:<id>` citation CMS can show. Another kind takes one entry here and its Trigger;
 * a kind missing from here is dropped.
 *
 * Each Trigger is a getter, read when a link renders rather than when this module loads: DocumentReferenceTrigger
 * is on an import cycle that leads back here, so where it is the first of that cycle to load, it is not yet defined
 * while this module loads.
 */
export const REFERENCE_KINDS: Record<string, ReferenceKind> = {
  // Document ids are sent bare: the server looks them up in the claim's own store.
  doc: {
    get Trigger() {
      return DocumentReferenceTrigger;
    },
    cacheKey: (id) => id,
  },
  expert: {
    get Trigger() {
      return ExpertReferenceTrigger;
    },
    cacheKey: (id) => `expert:${id}`,
  },
};
